import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import WorkersCard from '../../worker/components/WorkersCard';
import CardMessages from '../../messages-notifications/messages/to-refactor/card/CardMessages';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Row from '../../shared/components/Row';
import OutsourceDetailCard from '../components/OutsourceDetailCard';
import MachinesCard from '../../machines/components/MachinesCard';
import { connect } from 'react-redux';
import UserRole from '../../shared/model/UserRole';
import { PsCompanyManagement } from '../../shared/model/PsCompanyManagement';
import { DocumentsCards } from '../../shared/document/list/DocumentsCards';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../shared/utils/CardStorageManager';

class OutsourceDetailScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidUpdate(prevProps) {
        const { outsource: currentOutsource, location } = this.props;
        const { outsource: prevOutsource } = prevProps;

        if ( currentOutsource !== prevOutsource && currentOutsource ) {
            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DETAIL.id,
                url: location.pathname,
                description: currentOutsource.name,
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { breadcrumbs } = this.state;
        const { user, match } = this.props;

        if ( !user || !user.roles || !user.roles[0] ) {
            return null;
        }

        const roleId = user.roles[0].role.id;
        const outsourceId = match.params.id;

        if (
            roleId === UserRole.ADMIN ||
            roleId === UserRole.OUTSOURCES_MANAGER
        ) {
            return (
                <PsPage title={I18nUtils.tr('TR_MI_SUBCONTRATA')} breadcrumbs={breadcrumbs}>
                    <OutsourceDetailCard
                        outsourceId={outsourceId}
                    />
                    <Row>
                        <div className="col-md-12 col-lg-12">
                            <DocumentsCards
                                companyId={outsourceId}
                                companyManagement={PsCompanyManagement.MY_OUTSOURCES}
                                saveCardState={this.saveCardState}
                                readCardState={this.readCardState}
                            />
                            <WorkersCard
                                companyId={outsourceId}
                                includeOnlyCompanyWorkers={true}
                            />
                            <MachinesCard
                                companyId={outsourceId}
                                includeOnlyCompanyMachines={true}
                            />
                            <Row clearfix>
                                <CardMessages
                                    companyId={outsourceId}
                                    canAddMessage={true}
                                    canResponseMessage={true}
                                />
                            </Row>
                        </div>
                    </Row>
                </PsPage>
            );
        }

        if ( roleId === UserRole.OUTSOURCES_VIEWER ) {
            return (
                <PsPage title={I18nUtils.tr('TR_MI_SUBCONTRATA')} breadcrumbs={breadcrumbs}>
                    <OutsourceDetailCard
                        outsourceId={outsourceId}
                        editable={false}
                    />
                    <Row>
                        <div className="col-md-12">
                            <DocumentsCards
                                companyId={outsourceId}
                                companyManagement={PsCompanyManagement.MY_OUTSOURCES}
                                saveCardState={this.saveCardState}
                                readCardState={this.readCardState}
                            />
                            <WorkersCard companyId={outsourceId}/>
                            <MachinesCard companyId={outsourceId}/>
                        </div>
                    </Row>
                </PsPage>
            );
        }

        return null;
    }

    saveCardState = (card, state) => {
        this.cardStorageManager.saveCard(card, state);
    };

    readCardState = (card) => {
        return this.cardStorageManager.readCard(card);
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.auth.user,
        outsource: state.outsources.outsources[ownProps.match.params.id],
    };
};

export default connect(mapStateToProps)(OutsourceDetailScreen);

OutsourceDetailScreen.propTypes = {};

OutsourceDetailScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/outsource/screens/OutsourceDetailScreen.jsx